"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ProjectImage_1 = __importDefault(require("~/components/UI/Image/ProjectImage"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/project/actions");
const selectors_1 = require("~/store/project/selectors");
const EditProjectForm_1 = __importDefault(require("~/components/ProjectManagement/EditProjectForm"));
const utils_1 = require("~/utils/utils");
const assets_1 = require("~/assets");
const react_helmet_async_1 = require("react-helmet-async");
const routes_1 = require("~/consts/routes");
const events_1 = require("~/utils/events");
const actions_2 = require("~/store/actions");
const EditProjectModal_module_scss_1 = __importDefault(require("./EditProjectModal.module.scss"));
function EditProjectModal() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { t } = (0, react_i18next_1.useTranslation)('project');
    const navigate = (0, react_router_dom_1.useNavigate)();
    const projectId = Number((0, react_router_dom_1.useParams)().projectId);
    const project = (0, react_redux_1.useSelector)(selectors_1.selectProject);
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, react_1.useState)(true);
    const [projectData, setProjectData] = (0, react_1.useState)(project);
    const contentColumn = 'content-column';
    const { dispatchGetProject, dispatchEditProject, dispatchEditProjectSuccess, dispatchGetCurrentProjectSuccess, dispatchGetProjectSuccess, dispatchValidateTokenAction, } = (0, redux_1.bindActionCreators)({
        dispatchGetProject: actions_1.getProject,
        dispatchEditProject: actions_1.editProject,
        dispatchEditProjectSuccess: actions_1.editProjectSuccess,
        dispatchGetCurrentProjectSuccess: actions_1.getCurrentProjectSuccess,
        dispatchGetProjectSuccess: actions_1.getProjectSuccess,
        dispatchValidateTokenAction: actions_2.validateTokenAction,
    }, (0, react_redux_1.useDispatch)());
    const submitHandler = () => {
        dispatchValidateTokenAction(() => {
            (0, events_1.hideModal)();
            return navigate(routes_1.ROUTE_LOGIN);
        });
        if (projectData) {
            dispatchEditProject(projectData);
            dispatchGetCurrentProjectSuccess(projectData);
            dispatchGetProjectSuccess(projectData);
            dispatchEditProjectSuccess(false);
        }
        navigate(-1);
    };
    const cancelProjectedit = () => {
        navigate(-1);
    };
    (0, react_1.useEffect)(() => {
        if (!Number.isNaN(projectId)) {
            dispatchGetProject(projectId);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        setIsSubmitDisabled(!(projectData === null || projectData === void 0 ? void 0 : projectData.name));
    }, [projectData]);
    return (react_1.default.createElement(UI_1.ContentListModal, { headlineContent: react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.header },
            react_1.default.createElement(react_helmet_async_1.Helmet, null,
                react_1.default.createElement("title", null, "Edit Project | TBUILD")),
            react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.title }, t('edit-project')),
            react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.controls },
                react_1.default.createElement(UI_1.Button, { variant: "default", onClick: cancelProjectedit }, t('cancel')),
                react_1.default.createElement(UI_1.Button, { variant: "primary", onClick: submitHandler, disabled: isSubmitDisabled }, t('save')))), mainContent: react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.main },
            project ? (react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.details },
                react_1.default.createElement(ProjectImage_1.default, { project: project, defaultImg: assets_1.svgPlaceholdersExtrusionsSmallIcon }),
                react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.content },
                    react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default[contentColumn] },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.label }, t('reference-number')),
                            react_1.default.createElement("div", null,
                                project.referenceNumber,
                                ((_b = (_a = project.quotes) === null || _a === void 0 ? void 0 : _a.at(0)) === null || _b === void 0 ? void 0 : _b.revisionNumber) ? `-${project.quotes[0].revisionNumber}` : '')),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.label }, t('created-by')),
                            react_1.default.createElement("div", null, (_c = project.user) === null || _c === void 0 ? void 0 :
                                _c.firstName,
                                " ", (_d = project.user) === null || _d === void 0 ? void 0 :
                                _d.lastName))),
                    react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default[contentColumn] },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.label }, t('total-price')),
                            react_1.default.createElement("div", null,
                                "$", (_f = (_e = project.quotes) === null || _e === void 0 ? void 0 : _e.at(0)) === null || _f === void 0 ? void 0 :
                                _f.total)),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.label }, t('modified-by')),
                            react_1.default.createElement("div", null, (_g = project.modifier) === null || _g === void 0 ? void 0 :
                                _g.firstName,
                                " ", (_h = project.modifier) === null || _h === void 0 ? void 0 :
                                _h.lastName))),
                    react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default[contentColumn] },
                        react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.empty }),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: EditProjectModal_module_scss_1.default.label }, t('last-modified')),
                            react_1.default.createElement("div", null, (0, utils_1.formatTimeToRelative)(project.updatedAt))))))) : null,
            react_1.default.createElement(EditProjectForm_1.default, { onChange: setProjectData, project: project, editableStatus: true, openedInEditMode: true })) }));
}
exports.default = EditProjectModal;
